import request from '@/utils/request'

export function index(params) {
    return request({
        url: 'visitors/guest_coming_reasons',
        method: 'get',
        params: params
    })
}

export function inventory(params) {
    return request({
        url: 'visitors/guest_coming_reason/inventory',
        method: 'get',
        params: params
    })
}

export function show(id) {
    return request({
        url: `/visitors/guest_coming_reasons/${id}`,
        method: 'get'
    })
}

export function store(data) {
    return request({
        url: `visitors/guest_coming_reasons`,
        method: 'post',
        data
    })
}

export function update(data) {
    return request({
        url: `visitors/guest_coming_reasons/${data.id}`,
        method: 'put',
        data
    })
}

export function destroy(data) {
    return request({
        url: `visitors/guest_coming_reasons/${data.id}`,
        method: 'delete',
    })
}
